import { Dialog, DialogContent } from "common/components/ui/Dialog";

import DeleteWebhook from "./DeleteWebhook";
import TestWebhook from "./TestWebhook";
import WebhookForm from "./WebhookForm";

import type { JSX } from "react";
import type { Webhook } from "../../types";

interface WebhookDialogProps {
  webhook: Webhook;
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  action: "edit" | "delete" | "test";
}

export default function WebhookDialog({
  webhook,
  isOpen,
  setIsOpen,
  action,
}: WebhookDialogProps) {
  let component: JSX.Element;

  if (action === "delete") {
    component = (
      <DeleteWebhook
        webhook={webhook}
        onBack={() => setIsOpen(false)}
        onSuccess={() => setIsOpen(false)}
      />
    );
  } else if (action === "test") {
    component = (
      <TestWebhook
        webhookId={webhook.id}
        webhookEvents={webhook.events}
        onBack={() => setIsOpen(false)}
      />
    );
  } else if (action === "edit") {
    component = (
      <WebhookForm webhook={webhook} onBack={() => setIsOpen(false)} />
    );
  }

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent size={action === "delete" ? "md" : "lg"}>
        {component}
      </DialogContent>
    </Dialog>
  );
}
